export default __webpack_public_path__ + "static/media/typicalweek (7).a49e961f.png";